import React from "react";
import { useNavigate } from "react-router-dom";
import useService from "../../hooks/hook-service";
import { showSuccess } from "../../utils/message";
import CongressForm from "./CongressForm";

const CongressCreate = () => {
  const defaultCongress = {};

  const navigate = useNavigate();
  const { post } = useService();

  const createCongress = (congress) => {
    const request = {
      congress: congress,
    };
    post("congress/insert", request, () => {
      showSuccess("Se creo correctamente la asamblea");
      navigate(-1);
    });
  };

  return (
    <div className="p-fluid">
      <div className="grid">
        <div className="col-12">
          <div className="custom-card">
            <CongressForm
              headerClass="custom-card-header-create"
              title="Crear Asamblea"
              titleButton="Guardar"
              actionToExecute={createCongress}
              congress={defaultCongress}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CongressCreate;
